import { API_URL } from '../api'
const CDN_URL = 'https://cdn.colossus7.com'

// Convert /api/media/ URLs to CDN URLs; pass through absolute URLs.
// If the user has no avatar_url, returns null (caller should show fallback icon).
export function avatarUrl(user: { avatar_url?: string | null; avatar?: string | null } | null | undefined) {
  if (!user?.avatar_url) return undefined
  const url = user.avatar_url
  if (url.startsWith('/api/media/')) return CDN_URL + '/' + url.slice('/api/media/'.length)
  if (url.startsWith('/api/')) return API_URL + url
  return url
}

// Returns a proxied avatar URL by user ID (still needs API proxy because
// we don't have the avatar_url string, only the user ID).
export function avatarUrlById(userId: string) {
  if (!userId) return null
  return `${API_URL}/api/avatar/${userId}`
}
